import axios from 'axios';
import { getStorage } from 'src/utils/utils';

const testOnly = 'https://api.jspay.me';

const ENDPOINT = {
	DOWNLINE: {
		GET_DOWNLINE: (data) => `${testOnly}/downline?page=${data?.page}&limit=${data?.limit}`,
		GET_DOWNLINE_SELF: `${testOnly}/downline/self`,
	},
	PROVIDER: {
		GET_PROVIDER: `${testOnly}/payment-provider`,
		UPDATE: (_id) => `${testOnly}/payment-provider/${_id}`,
	},
	SUMMARY: {
		GET_SUM_DASHBOARD: `${testOnly}/summary/downline`,
		GET_ORDER_ID: (prefix) => `${testOnly}/payment/prefix?prefix=${prefix}`,
		GET_SUM_FUNDIN: (data) =>
			`${testOnly}/summary/downline-fundin?dateStart=${data?.dateStart}&dateEnd=${data?.dateEnd}&status=${data?.status}&page=${data?.page}&limit=${data?.limit}&refId=${data?.refId}`,
		GET_SUM_FUNDOUT: (data) =>
			`${testOnly}/summary/downline-fundout?dateStart=${data?.dateStart}&dateEnd=${data?.dateEnd}&status=${data?.status}&page=${data?.page}&limit=${data?.limit}&refId=${data?.refId}`,
		GET_SUM_SETTLEMENT: (data) =>
			`${testOnly}/summary/downline-settlement?dateStart=${data?.dateStart}&dateEnd=${data?.dateEnd}&paymentName=${data?.paymentName}&status=${data?.status}&page=${data?.page}&limit=${data?.limit}&refId=${data?.refId}`,
		GET_SUM_FUNDIN_ADMIN: (data) =>
			`${testOnly}/summary/fundin?paymentName=${data?.paymentName}&dateStart=${data?.dateStart}&dateEnd=${data?.dateEnd}&status=${data?.status}&page=${data?.page}&limit=${data?.limit}&refId=${data?.refId}`,
		GET_SUM_FUNDOUT_ADMIN: (data) =>
			`${testOnly}/summary/fundout?paymentName=${data?.paymentName}&dateStart=${data?.dateStart}&dateEnd=${data?.dateEnd}&status=${data?.status}&page=${data?.page}&limit=${data?.limit}&refId=${data?.refId}`,

		GET_SUMMARY: `${testOnly}/summary`,
		GET_PAYMENT_PROVIDER: `${testOnly}/payment-provider`,
		GET_UPLINE_SUMMARY_ADMIN: (data) =>
			`${testOnly}/summary/upline-summary?&page=${data?.page}&limit=${data?.limit}&dateStart=${data?.dateStart}&dateEnd=${data?.dateEnd}`,
		GET_DOWLINE_BY_PREFIX_ADMIN: (data) =>
			`${testOnly}/downline?&page=${data?.page}&limit=${data?.limit}&query=${data?.query}`,
	},
	PAYMENT: {
		TRANSFER: `${testOnly}/payment/downline-settlement`,
		DEPOSIT_TRANSFER: `${testOnly}/payment/downline-transfer`,
		// GEN_2FA: `${testOnly}/payment/downline-settlement`,
	},
	BANK: {
		GET_BANKLIST: `${testOnly}/user-bank/bank-list`,
		GET_LIST_USER_BANK: `${testOnly}/user-bank`,
		GET_USER_BANK_DETAIL: (_id) => `${testOnly}/user-bank/${_id}`,

		CREATE_USER_BANK: `${testOnly}/user-bank`,
		UPDATE_USER_BANK: (_id) => `${testOnly}/user-bank/${_id}`,
		DELETE_USER_BANK: (_id) => `${testOnly}/user-bank/${_id}`,
	},
};

export const PaymentServices = {
	getDownline: (data) => {
		return axios({
			method: 'GET',
			url: ENDPOINT.DOWNLINE.GET_DOWNLINE(data),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},
	getDownlineSelf: () => {
		return axios({
			method: 'GET',
			url: ENDPOINT.DOWNLINE.GET_DOWNLINE_SELF,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	getProvider: () => {
		return axios({
			method: 'GET',
			url: ENDPOINT.PROVIDER.GET_PROVIDER,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	getOrderID: (prefix) => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_ORDER_ID(prefix),
		});
	},

	getSummaryDashboard: () => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_SUM_DASHBOARD,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	getSummaryFoundIn: (data) => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_SUM_FUNDIN(data),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	getSummaryFoundOut: (data) => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_SUM_FUNDOUT(data),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	updateProvider: (data, _id) => {
		return axios({
			method: 'PATCH',
			url: ENDPOINT.PROVIDER.UPDATE(_id),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
			data,
		});
	},

	getSummarySettlements: (data) => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_SUM_SETTLEMENT(data),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	transfer: (data) => {
		return axios({
			method: 'POST',
			url: ENDPOINT.PAYMENT.TRANSFER,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
			data,
		});
	},
	depositTransfer: (data) => {
		return axios({
			method: 'POST',
			url: ENDPOINT.PAYMENT.DEPOSIT_TRANSFER,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
			data,
		});
	},

	// BANK
	getBanklist: () => {
		return axios({
			method: 'GET',
			url: ENDPOINT.BANK.GET_BANKLIST,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	getListuserbank: () => {
		return axios({
			method: 'GET',
			url: ENDPOINT.BANK.GET_LIST_USER_BANK,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	getUserBankdetail: (_id) => {
		return axios({
			method: 'GET',
			url: ENDPOINT.BANK.GET_USER_BANK_DETAIL(_id),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	createUserBank: (data) => {
		return axios({
			method: 'POST',
			url: ENDPOINT.BANK.CREATE_USER_BANK,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
			data,
		});
	},

	updateUserBank: (data, _id) => {
		return axios({
			method: 'PATCH',
			url: ENDPOINT.BANK.UPDATE_USER_BANK(_id),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
			data,
		});
	},

	delUserBank: (_id) => {
		return axios({
			method: 'DELETE',
			url: ENDPOINT.BANK.DELETE_USER_BANK(_id),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	// gen2FaTranfer: (data) => {
	// 	return axios({
	// 		method: 'POST',
	// 		url: ENDPOINT.PAYMENT.GEN_2FA,
	// 		headers: { Authorization: `Bearer ${getStorage('token')}` },
	// 		data,
	// 	});
	// },

	// ROLE ADMIN
	getSummaryFoundInAdmin: (data) => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_SUM_FUNDIN_ADMIN(data),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	getSummaryFoundOutAdmin: (data) => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_SUM_FUNDOUT_ADMIN(data),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},

	getSummary: () => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_SUMMARY,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},
	getPaymentProvider: () => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_PAYMENT_PROVIDER,
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},
	getUplineSummary: (data) => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_UPLINE_SUMMARY_ADMIN(data),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},
	getDowlineByPrefix: (data) => {
		return axios({
			method: 'GET',
			url: ENDPOINT.SUMMARY.GET_DOWLINE_BY_PREFIX_ADMIN(data),
			headers: { Authorization: `Bearer ${getStorage('token')}` },
		});
	},
};
